var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSocialIconLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.112 0H.886A.875.875 0 0 0 0 .865v10.268c0 .478.396.867.886.867h10.226c.49 0 .888-.39.888-.865V.865A.877.877 0 0 0 11.112 0M3.56 10.226H1.78V4.498H3.56zm-.89-6.509a1.032 1.032 0 1 1-.004-2.063 1.032 1.032 0 0 1 .004 2.063m7.556 6.509h-1.78V7.44c0-.663-.01-1.518-.925-1.518-.926 0-1.066.724-1.066 1.472v2.83H4.678V4.499h1.706v.782h.024c.237-.45.818-.925 1.683-.925 1.802 0 2.135 1.186 2.135 2.728z"
})));
export { SvgSocialIconLinkedin as ReactComponent };
export default __webpack_public_path__ + "d267736bba89ebfc0b85a7b043eb323f.svg";